import { CaretRight } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import MemberPermissionsTag from "common/components/MemberPermissionsTag";
import Skeleton from "common/components/ui/Skeleton";
import {
  Table,
  TableCell,
  TableHead,
  TableRow,
} from "common/components/ui/TableV2";
import { Tag } from "common/components/ui/Tag";
import WorkspaceImage from "common/components/WorkspaceImage";
import type { Workspace } from "common/types";

import useCampaignsCount from "../datahooks/useCampaignsCount";

function WorkspacesTableRow({ workspace }: { workspace: Workspace }) {
  const {
    id,
    license_count,
    accounts_count,
    name,
    role,
    rental_account_count,
    member_count,
    icon_url,
    permissions,
  } = workspace;

  const navigate = useNavigate();
  const { campaignsCount, isLoadingCampaignsCount } = useCampaignsCount(id);

  return (
    <TableRow onClick={() => navigate(`/workspaces/${id}`)}>
      <TableCell>
        <div className="flex items-center gap-x-2.5">
          <WorkspaceImage id={id} imageSrc={icon_url} />
          <span className="text-md-bold">{name}</span>
        </div>
      </TableCell>
      <TableCell>
        <MemberPermissionsTag permissions={permissions} role={role} />
      </TableCell>
      <TableCell className="text-button-xs">{license_count}</TableCell>
      <TableCell className="text-button-xs">{accounts_count}</TableCell>
      <TableCell className="text-button-xs">{rental_account_count}</TableCell>
      <TableCell className="text-button-xs">{member_count}</TableCell>
      <TableCell className="text-button-xs">
        {isLoadingCampaignsCount ? (
          <Skeleton className="h-4 w-8" />
        ) : (
          campaignsCount
        )}
      </TableCell>
      <TableCell>
        <CaretRight size={20} />
      </TableCell>
    </TableRow>
  );
}

export default function WorkspacesTable({
  workspaces,
}: {
  workspaces: Workspace[];
}) {
  return (
    <Table>
      <thead>
        <tr>
          <TableHead>
            My workspaces{" "}
            <Tag size="sm" className="ml-1" variant="tertiary">
              {workspaces.length}
            </Tag>
          </TableHead>
          <TableHead className="w-24">Role</TableHead>
          <TableHead className="w-24">Seats</TableHead>
          <TableHead className="w-24">Accounts</TableHead>
          <TableHead className="w-24">Avatars</TableHead>
          <TableHead className="w-24">Members</TableHead>
          <TableHead className="w-24">Campaigns</TableHead>
          <TableHead />
        </tr>
      </thead>

      <tbody className="mt-4">
        {workspaces.map((workspace) => (
          <WorkspacesTableRow key={workspace.id} workspace={workspace} />
        ))}
      </tbody>
    </Table>
  );
}
